<template>
  <div class="xn-table">
    <table>
      <thead>
        <tr>
          <th colspan="4">{{ balanceSheetDetail?balanceSheetDetail.companyName:'' }}</th>
        </tr>
        <tr>
          <th></th>
          <th>{{ tableTitle }}</th>
          <th style="width:30%">期末余额</th>
          <th style="width:25%">年初余额</th>
        </tr>
      </thead>
      <tbody ref="tbody" @scroll="scrollHandler">
        <tr v-for="(tr,index) in tableConfig" :key="index" :class="tr.className">
          <td>{{ tr.col1 }}</td>
          <td>{{ tr.col2 }}</td>
          <td style="width:25%">{{ tr.col3 ? tr.col3.toLocaleString() : '-' }}</td>
          <td style="width:25%">{{ tr.col4 ? tr.col4.toLocaleString() : '-' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: "BalancesSheetDetail",
    computed: {
      ...mapGetters(['balanceSheetDetail']),
      id() {
        return this.$route.params.balanceSheetId;
      },
      item() {
        return this.balanceSheetDetail || {};
      },
      tableConfig() {
        let data = [
          {className: 'bold', col1: '', col2: '流动资产', col3: ' ', col4: ' '},
          {className: '', col1: '1', col2: '货币资金', col3: this.item.c1, col4: this.item.r1},
          {className: '', col1: '2', col2: '短期投资', col3: this.item.c2, col4: this.item.r2},
          {className: '', col1: '3', col2: '应收票据', col3: this.item.c3, col4: this.item.r3},
          {className: '', col1: '4', col2: '应收账款', col3: this.item.c4, col4: this.item.r4},
          {className: '', col1: '5', col2: '预付账款', col3: this.item.c5, col4: this.item.r5},
          {className: '', col1: '6', col2: '应收股利', col3: this.item.c6, col4: this.item.r6},
          {className: '', col1: '7', col2: '应收利息', col3: this.item.c7, col4: this.item.r7},
          {className: '', col1: '8', col2: '其他应收款', col3: this.item.c8, col4: this.item.r8},
          {className: '', col1: '9', col2: '存货', col3: this.item.c9, col4: this.item.r9},
          {className: '', col1: '10', col2: '其中：原材料', col3: this.item.c10, col4: this.item.r10},
          {className: '', col1: '11', col2: '在产品', col3: this.item.c11, col4: this.item.r11},
          {className: '', col1: '12', col2: '库存商品', col3: this.item.c12, col4: this.item.r12},
          {className: '', col1: '13', col2: '周转材料', col3: this.item.c13, col4: this.item.r13},
          {className: '', col1: '14', col2: '其他流动资产', col3: this.item.c14, col4: this.item.r14},
          {className: '', col1: '15', col2: '流动资产合计', col3: this.item.c15, col4: this.item.r15},
          {className: 'bold', col1: '', col2: '非流动资产', col3: ' ', col4: ' '},
          {className: '', col1: '16', col2: '长期债券投资', col3: this.item.c16, col4: this.item.r16},
          {className: '', col1: '17', col2: '长期股权投资', col3: this.item.c17, col4: this.item.r17},
          {className: '', col1: '18', col2: '固定资产原价', col3: this.item.c18, col4: this.item.r18},
          {className: '', col1: '19', col2: '减：累计折旧', col3: this.item.c19, col4: this.item.r19},
          {className: '', col1: '20', col2: '固定资产账面价值', col3: this.item.c20, col4: this.item.r20},
          {className: '', col1: '21', col2: '在建工程', col3: this.item.c21, col4: this.item.r21},
          {className: '', col1: '22', col2: '工程物资', col3: this.item.c22, col4: this.item.r22},
          {className: '', col1: '23', col2: '固定资产清理', col3: this.item.c23, col4: this.item.r23},
          {className: '', col1: '24', col2: '生产性生物资产', col3: this.item.c24, col4: this.item.r24},
          {className: '', col1: '25', col2: '无形资产', col3: this.item.c25, col4: this.item.r25},
          {className: '', col1: '26', col2: '开发支出', col3: this.item.c26, col4: this.item.r26},
          {className: '', col1: '27', col2: '长期待摊费用', col3: this.item.c27, col4: this.item.r27},
          {className: '', col1: '28', col2: '其他非流动资产', col3: this.item.c28, col4: this.item.r28},
          {className: '', col1: '29', col2: '非流动资产合计', col3: this.item.c29, col4: this.item.r29},
          {className: '', col1: '30', col2: '资产总计', col3: this.item.c30, col4: this.item.r30},
          {className: 'bold', col1: '', col2: '流动负债', col3: ' ', col4: ' '},
          {className: '', col1: '31', col2: '短期借款', col3: this.item.c31, col4: this.item.r31},
          {className: '', col1: '32', col2: '应付票据', col3: this.item.c32, col4: this.item.r32},
          {className: '', col1: '33', col2: '应付账款', col3: this.item.c33, col4: this.item.r33},
          {className: '', col1: '34', col2: '预收账款', col3: this.item.c34, col4: this.item.r34},
          {className: '', col1: '35', col2: '应付职工薪酬', col3: this.item.c35, col4: this.item.r35},
          {className: '', col1: '36', col2: '应交税费', col3: this.item.c36, col4: this.item.r36},
          {className: '', col1: '37', col2: '应付利息', col3: this.item.c37, col4: this.item.r37},
          {className: '', col1: '38', col2: '应付利润', col3: this.item.c38, col4: this.item.r38},
          {className: '', col1: '39', col2: '其他应付款', col3: this.item.c39, col4: this.item.r39},
          {className: '', col1: '40', col2: '其他流动负债', col3: this.item.c40, col4: this.item.r40},
          {className: '', col1: '41', col2: '流动负债合计', col3: this.item.c41, col4: this.item.r41},
          {className: '', col1: '42', col2: '长期借款', col3: this.item.c42, col4: this.item.r42},
          {className: '', col1: '43', col2: '长期应付款', col3: this.item.c43, col4: this.item.r43},
          {className: '', col1: '44', col2: '递延收益', col3: this.item.c44, col4: this.item.r44},
          {className: '', col1: '45', col2: '其他非流动负债', col3: this.item.c45, col4: this.item.r45},
          {className: '', col1: '46', col2: '非流动负债合计', col3: this.item.c46, col4: this.item.r46},
          {className: '', col1: '47', col2: '负债合计', col3: this.item.c47, col4: this.item.r47},
          {className: '', col1: '48', col2: '实收资本（或股本）', col3: this.item.c48, col4: this.item.r48},
          {className: '', col1: '49', col2: '资本公积', col3: this.item.c49, col4: this.item.r49},
          {className: '', col1: '50', col2: '盈余公积', col3: this.item.c50, col4: this.item.r50},
          {className: '', col1: '51', col2: '未分配利润', col3: this.item.c51, col4: this.item.r51},
          {className: '', col1: '52', col2: '所有者权益（或股东权益）合计', col3: this.item.c52, col4: this.item.r52},
          {className: '', col1: '53', col2: '负债和所有者权益（或股东权益）总计', col3: this.item.c53, col4: this.item.r53},
        ];
        return data;
      }
    },
    methods: {
      ...mapActions(['getBalanceSheetDetail']),
      scrollHandler(){
        //console.log('scroll=',this.$refs.tbody.scrollTop)
        if(this.$refs.tbody.scrollTop>=1280){
          this.tableTitle = '负债和所有者权益';
        }else{
          this.tableTitle = '资产';
        }
      }
    },
    data(){
      return{
        tableTitle:'资产'
      }
    },
    watch: {
      balanceSheetDetail() {
        if (this.balanceSheetDetail) {
          let arr = this.balanceSheetDetail.month.split('-');
          window.document.title = `${arr[0]}年${arr[1]}月报表`;
        }
      }
    },
    created() {
      this.getBalanceSheetDetail(this.id);
    }
  }
</script>

<style scoped>

</style>